export default __webpack_public_path__ + "static/media/coinbase.b2b87a67.svg";